import { render, staticRenderFns } from "./form-step-3.vue?vue&type=template&id=0a2c5c72"
import script from "./form-step-3.vue?vue&type=script&lang=js"
export * from "./form-step-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports